import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StoreIcon from "@mui/icons-material/Store";
import { grey } from "@mui/material/colors";
import EditarGranProveedor from "./EditarGranProveedor";
import FormPeqProveedor from "../pequeños_proveedores/abm/FormPeqProveedor";
import CuentaCorrienteProveedor from "./CuentaCorrienteProveedor";

export default function FichaProveedor({ proveedor, onClose }) {
  const [opcion, setOpcion] = useState("datos");
  const esPequeno = Boolean(proveedor?.pequeno);

  const handleChangeTab = (_event, newValue) => {
    setOpcion(newValue);
  };

  return (
    <Container disableGutters maxWidth="xl">
      <Grid
        container
        my={1}
        backgroundColor="#1F618D"
        justifyContent="center"
        alignItems="center"
        borderRadius={5}
      >
        <Grid item xs={1}>
          <IconButton onClick={onClose} aria-label="Volver al listado">
            <ArrowBackIcon sx={{ color: grey[50] }} />
          </IconButton>
        </Grid>

        <Grid container justifyContent="center" alignItems="center" xs={10}>
          <StoreIcon sx={{ color: "#fff", fontSize: 25, mr: 1 }} />
          <Typography variant="body2" color="white" sx={{ fontSize: 20 }}>
            {`${proveedor?.razon_social || "Proveedor" }`}
          </Typography>
        </Grid>

        <Grid item xs={1} />
      </Grid>

      <Box sx={{ width: "100%" }}>
        <Tabs
          variant="fullWidth"
          value={opcion}
          onChange={handleChangeTab}
          indicatorColor="primary"
          aria-label="Detalle proveedor"
        >
          <Tab value="datos" label="Datos" />
          <Tab value="cc" label="Cuenta corriente" />
        </Tabs>
        <br />
      </Box>

      {opcion === "datos" ? (
        esPequeno ? (
          <FormPeqProveedor
            proveedor={proveedor}
            edicion
            soloLectura
            titulo={proveedor.razon_social}
          />
        ) : (
          <EditarGranProveedor
            row={proveedor}
            soloLectura
            hideTitle
            settabla={onClose}
          />
        )
      ) : null}

      {opcion === "cc" ? (
        <CuentaCorrienteProveedor proveedor={proveedor} />
      ) : null}
    </Container>
  );
}
